export default "__VITE_PUBLIC_ASSET__8906e1a1__"